module.exports = __webpack_public_path__ + "static/media/logo_missiontimothee.2e1ec3b2.svg";